import PropTypes from 'prop-types';
import warningLogoUrl from './warning-logo.svg';

export const YouWarningIcon = ({ size = 48, alt = '' }) => (
  <img
    src={warningLogoUrl}
    alt={alt}
    width={size}
    height={size}
    data-testid="you-warning-icon"
  />
);

YouWarningIcon.propTypes = {
  size: PropTypes.number,
  alt: PropTypes.string,
};

export default YouWarningIcon;
